/* tslint:disable */
/* eslint-disable */
/**
 * Y-sports-Core API
 * API for managing Y-sports related stuff
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TeamEdit
 */
export interface TeamEdit {
    /**
     * 
     * @type {string}
     * @memberof TeamEdit
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamEdit
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamEdit
     */
    clubName?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamEdit
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamEdit
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamEdit
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamEdit
     */
    homeColor?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamEdit
     */
    awayColor?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamEdit
     */
    goalkeeperColor?: string;
}

/**
 * Check if a given object implements the TeamEdit interface.
 */
export function instanceOfTeamEdit(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TeamEditFromJSON(json: any): TeamEdit {
    return TeamEditFromJSONTyped(json, false);
}

export function TeamEditFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamEdit {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'clubName': !exists(json, 'clubName') ? undefined : json['clubName'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'homeColor': !exists(json, 'homeColor') ? undefined : json['homeColor'],
        'awayColor': !exists(json, 'awayColor') ? undefined : json['awayColor'],
        'goalkeeperColor': !exists(json, 'goalkeeperColor') ? undefined : json['goalkeeperColor'],
    };
}

export function TeamEditToJSON(value?: TeamEdit | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'clubName': value.clubName,
        'country': value.country,
        'state': value.state,
        'city': value.city,
        'homeColor': value.homeColor,
        'awayColor': value.awayColor,
        'goalkeeperColor': value.goalkeeperColor,
    };
}

